import * as types from '../../../types/masters/uom/uomTypes.js';
import * as api from '../../../../api/masters/uom/uomApi.js';

export const fetchUoms = () => async (dispatch) => {
  dispatch({ type: types.FETCH_UOM_REQUEST });
  try {
    const data = await api.fetchUoms();
    dispatch({ type: types.FETCH_UOM_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_UOM_FAILURE, payload: error.message });
  }
};

export const addUom = (uom) => async (dispatch) => {
  try {
    const res = await api.addUom(uom);
    dispatch({ type: types.ADD_UOM_SUCCESS, payload: res });
    dispatch(fetchUoms());
  } catch (error) {
    dispatch({ type: types.UOM_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateUom = (id, uom) => async (dispatch) => {
  try {
    const res = await api.updateUom(id, uom);
    dispatch({ type: types.UPDATE_UOM_SUCCESS, payload: res });
    dispatch(fetchUoms());
  } catch (error) {
    dispatch({ type: types.UOM_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteUom = (id) => async (dispatch) => {
  try {
    await api.deleteUom(id);
    dispatch({ type: types.DELETE_UOM_SUCCESS, payload: id });
    dispatch(fetchUoms());
  } catch (error) {
    dispatch({ type: types.UOM_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setUomEdit = (uom) => ({
  type: types.SET_UOM_EDIT,
  payload: uom,
});

export const clearUomEdit = () => ({
  type: types.CLEAR_UOM_EDIT,
}); 